// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flight-type[data-v-00f09e04]  .el-form-item__content {\n  width: 12em;\n}\n.el-select-dropdown__item span[data-v-00f09e04] {\n  padding-left: 5px;\n  padding-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
